// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"ChangePrice_text-gradient__2Bbzi","text":"ChangePrice_text__exl_j","btns":"ChangePrice_btns__3M6bi","button":"ChangePrice_button__1L589"};